import React from 'react';
import { Box, Text, Image } from '@chakra-ui/react';
import { motion, AnimatePresence } from 'framer-motion';

const ActiveCardModalDisplay = ({ activeCard, containerRef, onClose }) => (
  <AnimatePresence>
    {activeCard && (
      <>
        <Box
          position="fixed"
          top={0}
          left={0}
          w="100vw"
          h="100vh"
          zIndex={998}
          onClick={onClose}
        />
        <motion.div
          ref={containerRef}
          initial={{ opacity: 0, top: "100%", left: "50%" }}
          animate={{
            opacity: 1,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
          exit={{ opacity: 0, top: "100%" }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          style={{
            position: "fixed",
            zIndex: 999,
            width: window.innerWidth <= 768 ? "90vw" : "45vw",
            height: window.innerWidth <= 768 ? "80vh" : "75vh",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <Box bg="white" borderRadius="lg" boxShadow="2xl" h="100%">
            <Image
              src={activeCard.image}
              alt={activeCard.title}
              w="100%"
              h="60%"
              objectFit="cover"
              borderTopRadius="lg"
            />
            <Box p={{ base: 3, md: 4 }} h="40%">
              <Text 
                fontSize={{ base: "lg", md: "2xl" }} 
                fontWeight="bold" 
                mb={2}
              >
                {activeCard.title}
              </Text>
              <Text fontSize={{ base: "sm", md: "md" }}>
                {activeCard.text}
              </Text>
            </Box>
          </Box>
        </motion.div>
      </>
    )}
  </AnimatePresence>
);

export default ActiveCardModalDisplay;